/* ICE Diamonds — social-proof story player

   Reads the clips straight off the circle buttons' data attributes, so there
   is no JSON blob to keep in sync with the markup.

   PLACEMENT is decided here, not in Liquid. The block is rendered once, in the
   panel under the delivery box — which is exactly where it belongs on a phone,
   between "הזמנתם היום" and "פרטי המוצר". On desktop it moves into the media
   column under the reviews, filling the white space beside the buy box. A
   matchMedia listener moves it back on resize, so the two layouts stay honest
   without duplicating the markup.

   AUTOPLAY WITH SOUND is blocked by every browser until the user has
   interacted. Opening the player IS that interaction, so sound is on from the
   first clip — but the play() promise is still caught, and on rejection the
   clip is muted and retried rather than sitting frozen on a black frame.

   Progress is driven by timeupdate rather than a CSS animation, because a
   clip that stalls on a slow connection would otherwise show a bar racing
   ahead of a picture that has not moved. */

(function(){
  'use strict';

  var DESKTOP = '(min-width: 901px)';

  var modal, stage, video, bars, btnPause, btnMute, navPrev, navNext;
  var clips = [], index = 0;

  function svg(paths, fill){
    return '<svg viewBox="0 0 24 24" aria-hidden="true" ' +
           (fill ? 'fill="currentColor" stroke="none"' : 'fill="none"') + '>' + paths + '</svg>';
  }

  var ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18" stroke="#fff" stroke-width="2.2" stroke-linecap="round" fill="none"/>',
    pause: '<path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="#fff" stroke="none"/>',
    play:  '<path d="M8 5.5v13l10-6.5z" fill="#fff" stroke="none"/>',
    on:    '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff" stroke="none"/><path d="M17 8.5a5 5 0 0 1 0 7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/>',
    off:   '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff" stroke="none"/><path d="M17 9.5l4 5M21 9.5l-4 5" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/>',
    prev:  '<path d="M9 6l6 6-6 6"/>',
    next:  '<path d="M15 6l-6 6 6 6"/>'
  };

  /* ---------------- build the player once ---------------- */

  function build(){
    if(modal) return;

    modal = document.createElement('div');
    modal.className = 'ist-modal';
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-hidden','true');

    modal.innerHTML =
      '<button type="button" class="ist-nav ist-nav--prev" aria-label="\u05d4\u05e7\u05d5\u05d3\u05dd">' + svg(ICON.prev) + '</button>' +
      '<div class="ist-stage">' +
        '<div class="ist-bars"></div>' +
        '<video playsinline preload="metadata"></video>' +
        '<button type="button" class="ist-ctl ist-ctl--close" aria-label="\u05e1\u05d2\u05d9\u05e8\u05d4">' + svg(ICON.close) + '</button>' +
        '<button type="button" class="ist-ctl ist-ctl--pause" aria-label="\u05d4\u05e9\u05d4\u05d9\u05d4">' + svg(ICON.pause) + '</button>' +
        '<button type="button" class="ist-ctl ist-ctl--mute" aria-label="\u05e7\u05d5\u05dc">' + svg(ICON.on) + '</button>' +
      '</div>' +
      '<button type="button" class="ist-nav ist-nav--next" aria-label="\u05d4\u05d1\u05d0">' + svg(ICON.next) + '</button>';

    document.body.appendChild(modal);

    stage    = modal.querySelector('.ist-stage');
    video    = modal.querySelector('video');
    bars     = modal.querySelector('.ist-bars');
    btnPause = modal.querySelector('.ist-ctl--pause');
    btnMute  = modal.querySelector('.ist-ctl--mute');
    navPrev  = modal.querySelector('.ist-nav--prev');
    navNext  = modal.querySelector('.ist-nav--next');

    modal.querySelector('.ist-ctl--close').addEventListener('click', close);
    btnPause.addEventListener('click', togglePause);
    btnMute.addEventListener('click', toggleMute);
    navPrev.addEventListener('click', function(){ go(index - 1); });
    navNext.addEventListener('click', function(){ go(index + 1); });

    modal.addEventListener('click', function(e){
      if(e.target === modal) close();
    });

    video.addEventListener('timeupdate', paint);
    video.addEventListener('ended', function(){
      if(index >= clips.length - 1) close(); else go(index + 1);
    });

    /* on a phone the chevrons are hidden — tap the sides of the frame */
    stage.addEventListener('click', function(e){
      if(e.target.closest('.ist-ctl')) return;
      if(window.matchMedia(DESKTOP).matches) return;
      var r = stage.getBoundingClientRect();
      var third = r.width / 3;
      var x = e.clientX - r.left;
      /* RTL: the right third is "previous" */
      if(x > r.width - third) go(index - 1);
      else if(x < third) go(index + 1);
      else togglePause();
    });

    document.addEventListener('keydown', function(e){
      if(!modal.classList.contains('is-open')) return;
      if(e.key === 'Escape') close();
      if(e.key === 'ArrowLeft')  go(index + 1);
      if(e.key === 'ArrowRight') go(index - 1);
      if(e.key === ' '){ e.preventDefault(); togglePause(); }
    });
  }

  /* ---------------- progress ---------------- */

  function drawBars(){
    bars.innerHTML = '';
    clips.forEach(function(){
      var b = document.createElement('span');
      b.className = 'ist-bar';
      b.innerHTML = '<span class="ist-bar__fill"></span>';
      bars.appendChild(b);
    });
  }

  function paint(){
    var fills = bars.querySelectorAll('.ist-bar__fill');
    var pct = (video.duration && isFinite(video.duration))
      ? Math.min(100, (video.currentTime / video.duration) * 100) : 0;
    fills.forEach(function(f, i){
      f.style.width = i < index ? '100%' : (i === index ? pct + '%' : '0%');
    });
  }

  /* ---------------- playback ---------------- */

  function go(i){
    if(i < 0 || i >= clips.length) return;
    index = i;

    video.src = clips[i].src;
    if(clips[i].poster) video.poster = clips[i].poster;
    video.currentTime = 0;

    var p = video.play();
    if(p && p.catch){
      p.catch(function(){
        /* sound was refused — keep the clip moving rather than freezing */
        video.muted = true;
        btnMute.innerHTML = svg(ICON.off);
        video.play().catch(function(){});
      });
    }

    btnPause.innerHTML = svg(ICON.pause);
    navPrev.disabled = (i === 0);
    navNext.disabled = (i === clips.length - 1);
    paint();
  }

  function togglePause(){
    if(video.paused){ video.play().catch(function(){}); btnPause.innerHTML = svg(ICON.pause); }
    else { video.pause(); btnPause.innerHTML = svg(ICON.play); }
  }

  function toggleMute(){
    video.muted = !video.muted;
    btnMute.innerHTML = svg(video.muted ? ICON.off : ICON.on);
  }

  function open(i){
    build();
    drawBars();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    video.muted = false;
    btnMute.innerHTML = svg(ICON.on);
    go(i);
  }

  function close(){
    if(!modal) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  /* ---------------- placement ---------------- */

  function place(block){
    var root = block.closest('[data-itp-root]');
    if(!root) return;

    var media = root.querySelector('.itp__media');
    var info  = root.querySelector('.itp-info');

    if(window.matchMedia(DESKTOP).matches){
      if(media && block.parentElement !== media) media.appendChild(block);
    } else if(info && block.previousElementSibling !== info){
      info.insertAdjacentElement('afterend', block);
    }
  }

  /* ---------------- init ---------------- */

  function init(){
    document.querySelectorAll('[data-ist]').forEach(function(block){
      if(!block.dataset.istReady){
        block.dataset.istReady = '1';

        block.querySelectorAll('[data-ist-open]').forEach(function(btn){
          btn.addEventListener('click', function(){
            clips = Array.prototype.map.call(
              block.querySelectorAll('[data-ist-open]'),
              function(b){ return { src: b.getAttribute('data-src'), poster: b.getAttribute('data-poster') }; }
            ).filter(function(c){ return c.src; });

            var i = parseInt(btn.getAttribute('data-ist-open'), 10) || 0;
            if(clips.length) open(i);
          });
        });

        var mq = window.matchMedia(DESKTOP);
        var move = function(){ place(block); };
        mq.addEventListener ? mq.addEventListener('change', move) : mq.addListener(move);
      }
      place(block);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
})();
